import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import * as yup from "yup";
import AppAlert from "../../components/AppAlert";
import SolidBlueBtn from "../../components/buttons/SolidBlueBtn";
import AppInput from "../../components/controls/AppInput";
import AppInputPassword from "../../components/controls/AppInputPassword";
import Spinner from "../../components/spinner/Spinner";
import { RESULT_CODE } from "../../constants/AppConstants";
import { ROUTE_PATHS } from "../../constants/Router";
import useAuth from "../../hooks/useAuth";
const SignIn = function () {
  const { login, logout } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [openFail, setOpenFail] = useState(false);
  const [openShopIsDeleted, setOpenShopIsDeleted] = useState(false);

  const schema = yup.object().shape({
    id: yup.string().required(),
    password: yup.string().required(),
  });
  const { control, handleSubmit, watch } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      id: "",
      password: "",
    },
  });

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const res = await login(data);
      if (res.result_code === RESULT_CODE.LOGIN_FAIL) {
        setOpenFail(true);
        
      }
      else if(res.result_code === RESULT_CODE.INVALID_REQUEST){
        setOpenShopIsDeleted(true);
      } else {
        navigate(ROUTE_PATHS.Home,{ replace: true });
      }
    } finally {
      setLoading(false);
    }
  };

  const values = watch();

  return (
    <div className="mt-4 mx-5">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="h-4"></div>
        <AppInput
          control={control}
          name="id"
          placeholder="가입하신 아이디를 입력해 주세요."
          label="아이디"
          className="mb-5"
          clearable
        />

        <AppInputPassword
          control={control}
          name="password"
          placeholder="비밀번호를 입력해 주세요."
          label="비밀번호"
          clearable
        />

        <SolidBlueBtn
          disabled={!values.password || !values.id || loading}
          className="w-full mt-6 flex items-center justify-center"
          type="submit"
        >
          <Spinner isLoading={loading} />
          로그인
        </SolidBlueBtn>

        <div className="flex items-center text-datesub mt-5 justify-center gap-3">
          <Link to={ROUTE_PATHS.FindId}>
            <span>아이디 찾기</span>
          </Link>
          <span className="separator">|</span>
          <Link to={ROUTE_PATHS.FindPassword}>
            <span>비밀번호 찾기</span>
          </Link>
        </div>
      </form>

      <AppAlert
        desc='아이디와 비밀번호를 확인하고 <br/>
        다시 입력해 주세요'
        open={openFail}
        onOk={() => setOpenFail(false)}
        okText="확인"
      />
      <AppAlert
        title='해지 된 가맹점입니다.'
        desc='해지 된 가맹점임니다.<br/>
        매장 담당자에게 연락해 주세요.'
        open={openShopIsDeleted}
        type="error"
        onOk={() => setOpenShopIsDeleted(false)}
        okText="확인"
      />
    </div>
  );
};
export default SignIn;
